const initialState = {
  storeProducts: [],
  storeProductCategories: [],
  storeProductProviders: [],
};

const StoreProducts = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_STORE_PRODUCTS':
      return {
        ...state,
        storeProducts: action.storeProducts,
      };
    case 'SET_STORE_PRODUCT_CATEGORIES':
      return {
        ...state,
        storeProductCategories: action.storeProductCategories,
      };
    case 'SET_STORE_PRODUCT_PROVIDERS':
      return {
        ...state,
        storeProductProviders: action.storeProductProviders,
      };
    case 'RESET_STORE_PRODUCTS':
      return {
        ...state,
        storeProducts: initialState.storeProducts,
      };
    default:
      return state;
  }
};

export default StoreProducts;
